import loadingIcon from '../../../assets/images/logogg88.png';

export default function PageLoading() {
  return (
    <div className="w-90 d-flex justify-content-center align-items-center" style={{ height: '99vh' }}>
      <img style={{ width: '200px' }} src={loadingIcon} alt="loading-icon" />
    </div>
  )
}